import { render, staticRenderFns } from "./fruitList.vue?vue&type=template&id=2dba94f7&scoped=true&"
import script from "./fruitList.vue?vue&type=script&lang=js&"
export * from "./fruitList.vue?vue&type=script&lang=js&"
import style0 from "./fruitList.vue?vue&type=style&index=0&id=2dba94f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba94f7",
  null
  
)

export default component.exports